@if (inShell) {
  <!-- Inside the console: the shell stays, the way back is a click away -->
  <div class="bk-page nf">
    <header class="bk-page__head">
      <div class="bk-page__intro">
        <p class="bk-eyebrow">Error 404</p>
        <h1 class="bk-page__title">This page doesn’t exist</h1>
        <p class="bk-page__sub">
          Nothing lives at <span class="nf__path">{{ path }}</span>. The link may be old or mistyped.
        </p>
      </div>
      @if (canGoBack) {
        <div class="bk-page__actions">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="goBack()">
            <span class="bk-sym" aria-hidden="true">arrow_back</span>
            Go back
          </button>
        </div>
      }
    </header>

    <nav class="bk-panel nf__panel" aria-labelledby="nf-next">
      <h2 class="bk-eyebrow nf__label" id="nf-next">Go to</h2>
      <ul class="nf__list">
        @for (item of destinations; track item.link) {
          <li>
            <a class="nf__link" [routerLink]="item.link">
              <span class="nf__icon" aria-hidden="true"><span class="bk-sym">{{ item.icon }}</span></span>
              <span class="nf__text">
                <span class="nf__name">{{ item.label }}</span>
                <span class="nf__desc">{{ item.description }}</span>
              </span>
              <span class="bk-sym nf__arrow" aria-hidden="true">arrow_forward</span>
            </a>
          </li>
        }
      </ul>
    </nav>
  </div>
} @else {
  <!-- Outside the console: the signed-out layout -->
  <bk-auth-layout eyebrow="Error 404" heading="This page doesn’t exist" [showEnvironment]="false">
    <!-- The path is a plain fact, so it reads as the subtitle (as in the shell), not a status note -->
    <p class="bk-auth__sub" authSub>
      Nothing lives at <span class="nf__path">{{ path }}</span>. The link may be old or mistyped.
    </p>

    <!-- Signed-in state and history exist only in the browser. Deferring the
         actions keeps the server's paint from showing the wrong one first; the
         placeholder holds the button's space so nothing shifts. -->
    @defer (on immediate) {
      @if (signedIn) {
        <a class="bk-btn bk-btn--primary bk-auth-cta" routerLink="/organization/dashboard">Go to dashboard</a>
      } @else {
        <a class="bk-btn bk-btn--primary bk-auth-cta" routerLink="/">Go to sign in</a>
      }

      @if (canGoBack) {
        <p class="bk-auth-alt">
          <button type="button" class="bk-auth-link" (click)="goBack()">Go back</button>
        </p>
      }
    } @placeholder {
      <div class="nf__cta-slot" aria-hidden="true"></div>
    }
  </bk-auth-layout>
}
